import { Upload } from "./base.js";

//#region ../base/upload/base-file.ts
var UploadFile = class extends Upload {
	/**
	* Source file to upload
	*/
	file;
	abortController = new AbortController();
	constructor(params) {
		super(params);
		this.file = params.file;
	}
	async _upload() {
		throw new Error("Not implemented");
	}
	async start(force = false) {
		if (await super.start(force) !== true) return;
		this._upload();
		return true;
	}
	abort() {
		if (super.abort() !== true) return;
		this.abortController.abort();
	}
};

//#endregion
export { UploadFile };
//# sourceMappingURL=base-file.js.map